import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { isLocale, type Locale } from '@neke/core';
import ru from './locales/ru.json';
import kk from './locales/kk.json';

const STORAGE_KEY = 'neke.locale';

/** Порядок источника языка: ?lang= → localStorage → язык браузера → kk. */
export function detectLocale(): Locale {
  const fromQuery = new URLSearchParams(window.location.search).get('lang');
  if (isLocale(fromQuery)) return fromQuery;

  const stored = localStorage.getItem(STORAGE_KEY);
  if (isLocale(stored)) return stored;

  // Русский показываем только тем, у кого браузер русскоязычный; по умолчанию — казахский.
  return navigator.language.toLowerCase().startsWith('ru') ? 'ru' : 'kk';
}

export function persistLocale(locale: Locale): void {
  localStorage.setItem(STORAGE_KEY, locale);
  document.documentElement.lang = locale;
}

void i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru }, kk: { translation: kk } },
  lng: detectLocale(),
  fallbackLng: 'kk',
  interpolation: { escapeValue: false },
});

persistLocale(detectLocale());

export default i18n;
